// extracted by mini-css-extract-plugin
export default {"wallet-card":"walletCard_wallet-card__4nI+Q"};